<!-- barcode-report-viewer.html
     Minimal host template — the actual report renders inside the #viewer div
     via Stimulsoft's renderHtml('viewer') call in the component. -->

<div class="barcode-report-viewer-host">
  <div id="viewer" [class.previewMode]="!windowMode"></div>
</div>